import * as React from 'react';

function SvgRoleBc(props) {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#role-BC_svg__a)">
        <circle cx={16} cy={16} r={16} fill="#38B2A6" />
        <path
          d="M16 8.13a7.88 7.88 0 100 15.75 7.88 7.88 0 000-15.75zm-3.94 6.27a.84.84 0 011.69 0 .84.84 0 01-1.69 0zM16 19.18a2.82 2.82 0 01-2.8-2.72.14.14 0 01.13-.1h.84c.08 0 .14.07.15.14a1.69 1.69 0 003.36 0c0-.07.07-.13.15-.13h.84a.14.14 0 01.13.1l.01.05A2.82 2.82 0 0116 19.18zm3.1-3.94a.84.84 0 010-1.68.84.84 0 010 1.68z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="role-BC_svg__a">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRoleBc;
